module.exports = __webpack_public_path__ + "static/media/prev-page.5821dc5e.svg";